import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatChipListbox, MatChip, MatChipRemove } from '@angular/material/chips';
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIconButton, MatButton } from '@angular/material/button';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'sibat-batch-egid-edit-dialog',
  templateUrl: './batch-egid-edit-dialog.component.html',
  imports: [
    MatDialogTitle,
    MatIcon,
    CdkScrollable,
    MatDialogContent,
    MatChipListbox,
    MatChip,
    MatChipRemove,
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    FormsModule,
    MatIconButton,
    MatSuffix,
    MatDialogActions,
    MatButton,
    TranslocoPipe,
  ],
})
export class BatchEgidEditDialogComponent {
  egids: number[] = [];
  newEgid?: number;
  readonly max = 5;

  constructor(
    private dialogRef: MatDialogRef<BatchEgidEditDialogComponent, number[]>,
    @Inject(MAT_DIALOG_DATA) private data: { egids: number[] }
  ) {
    this.egids = [...(data.egids ?? [])];
  }

  add() {
    if (!this.newEgid) {
      return;
    }

    if (this.egids.includes(this.newEgid)) {
      return;
    }

    if (this.egids.length >= this.max) {
      return;
    }

    this.egids.push(this.newEgid);
    this.newEgid = undefined;
  }

  remove(index: number) {
    this.egids.splice(index, 1);
  }

  save() {
    this.dialogRef.close(this.egids);
  }

  cancel() {
    this.dialogRef.close();
  }
}
